import { Content } from "antd/es/layout/layout";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../utils/context/UserContext";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Typography,
  message,
} from "antd";
import ExpenseCatDefaulType from "../../utils/types/ExpenseCatDefaulType";
import { getOutletExpenseCategories } from "../../utils/api/OutletAPI";
import {
  addExpenseCat,
  updateExpenseCat,
  deleteExenseCat,
} from "../../utils/api/ExpenseCatAPI";
import { IoIosRefresh } from "react-icons/io";
import { AiOutlinePlus } from "react-icons/ai";
import {
  ERROR_NOTIFICATION_TYPE,
  SUCCESS_NOTIFICATION_TYPE,
  getAPIResponseMessage,
} from "../../utils/api/_ConstantsAPI";
import { GlobalContext } from "../../App";
import { getExpenseCategoryTable } from "../../utils/tableData/Maintenance/ExpenseCategoryTable";
import { getExpenseCategoryMaintenanceFields } from "../../utils/data/ExpenseCategoryField";
import { FormInput } from "../../components";
import Search from "antd/es/input/Search";

export default function CategoriesMaintenance() {
  const { authToken, openNotification } = useContext(GlobalContext);
  const { profile, formItemLayout } = useContext(UserContext);
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentExpCatState, setcurrentExpCatState] =
    useState(ExpenseCatDefaulType);
  const [tableHeaderFilter, setTableHeaderFilter] = useState("");
  const [tableFilter, setTableFilter] = useState("");

  const [localexpenseCategoryList, setExpenseCategoryList] = useState([]);



  let tableContents = localexpenseCategoryList
    .filter((data) => {
      if (tableHeaderFilter === '') {
        return data;
      }
      return data[tableHeaderFilter]
        .toString()
        .toLowerCase()
        .includes(tableFilter.toLowerCase());
    })
    .map((data, index) => ({
      ...data,
      key: index,
    }));

  const getParseExpenseCategoryData = () => {
    const parseData = {
      id: currentExpCatState.id,
      categoryDesc: currentExpCatState.categoryDesc,
      updatedBy: profile.id,
      is_add_ons:currentExpCatState.is_add_ons, 
    };
    return parseData;
  };

  const fetchExpenseCategoryList = async () => {
    setIsLoading(true);
    resetData();
    const res = await getOutletExpenseCategories();
    console.log(res);
    if (res.isSuccess) {
      setExpenseCategoryList(res.categoryList);
    } else {
      openNotification(
        ERROR_NOTIFICATION_TYPE,
        "Expense Ctegory",
        getAPIResponseMessage(res.categoryList)
      );
    }
    setIsLoading(false);
  };


  const handleAction = async (id, action) => {
    setIsLoading(true);
    if (action === "edit") {
      const expcategory = localexpenseCategoryList.find(
        (expcat) => expcat.id === id
      );
      setcurrentExpCatState({ ...expcategory });
      form.setFieldsValue(expcategory);
      setIsModalOpen(true);
    } else if (action === "delete") {
      const res = await deleteExenseCat({
        id: id,
      });
      if (res.isSuccess) {
        fetchExpenseCategoryList();
        openNotification(
          SUCCESS_NOTIFICATION_TYPE,
          "Expense Category",
          "Expense Category successfully deleted."
        );
      } else {
        openNotification(
          ERROR_NOTIFICATION_TYPE,
          "Expense Category",
          "There was a problem deleting the Expense Category."
        );
      }
    }
    setIsLoading(false);
  };

  const handleModalSave = async () => {
    setIsLoading(true);
    try {
      await form.validateFields();
      if (currentExpCatState.id === "") {
        // New product flow
        const res = await addExpenseCat(getParseExpenseCategoryData());
        if (res.isSuccess) {
          setIsModalOpen(false);
          openNotification(
            SUCCESS_NOTIFICATION_TYPE,
            "Expense Category",
            "Expense Category successfully added."
          );
          fetchExpenseCategoryList();
        } else {
          openNotification(
            ERROR_NOTIFICATION_TYPE,
            "Expense Category",
            getAPIResponseMessage(res.message)
          );
        }
      } else {
        // Edit product flow
        const res = await updateExpenseCat(getParseExpenseCategoryData());
        console.log(res);
        if (res.isSuccess) {
          setIsModalOpen(false);
          openNotification(
            SUCCESS_NOTIFICATION_TYPE,
            "Expense Category",
            "Expense Category successfully updated."
          );
          fetchExpenseCategoryList();
        } else {
          openNotification(
            ERROR_NOTIFICATION_TYPE,
            "Expense Category",
            "There was a problem updating the Expense Category."
          );
        }
      }
    } catch (error) {
      // No action needed.
    }
    setIsLoading(false);
  };



  
  const resetData = () => {
    setTableHeaderFilter("");
    setTableFilter("");
    setcurrentExpCatState(ExpenseCatDefaulType);
    form.setFieldsValue(ExpenseCatDefaulType);
  };

  useEffect(() => {
    if (localexpenseCategoryList.length === 0) {
      fetchExpenseCategoryList();
    }
  }, []);

  useEffect(() => {
    const fetchDataInterval = setInterval(() => {
      fetchExpenseCategoryList();
    }, 1800000);

    return () => {
      clearInterval(fetchDataInterval);
    };
  }, []);

  return (
    <Content>
      <Row align={"middle"} className="mb-4">
        <Col xs={24} md={12}>
          <Typography.Title level={3}>
            ExpenseCategory Maintenance
          </Typography.Title>
        </Col>
        <Col xs={24} md={12} className="text-end">
          <Button
            type="primary"
            size="large"
            icon={<IoIosRefresh size={24} />}
            loading={isLoading}
            onClick={() => fetchExpenseCategoryList()}
          />
          <Button
            type="primary"
            size="large"
            icon={<AiOutlinePlus size={24} />}
            loading={isLoading}
            className="ms-3"
            onClick={async () => {
              resetData();
              setIsModalOpen(true);
            }}
          />
        </Col>
      </Row>
      <Row className="mb-4">
        <Space.Compact>
          <Select
            style={{ minWidth: "10vw" }}
            placeholder="Filters"
            value={tableHeaderFilter}
            onChange={(e) => {
              setTableHeaderFilter(e);
            }}
            disabled={isLoading}
            options={getExpenseCategoryTable(null)
              .filter((header) => header.key !== "actions")
              .map((option) => ({
                label: option.title,
                value: option.key,
              }))}
          />
          <Search
            placeholder="Search for expense category"
            disabled={isLoading || tableHeaderFilter === ""}
            value={tableFilter}
            onSearch={(value) => {
              setTableFilter(value);
            }}
            onChange={(e) => {
              const searchValue = e.target.value;
              setTableFilter(searchValue);
            }}
            allowClear={true}
          />
        </Space.Compact>
      </Row>
      <Table
        columns={getExpenseCategoryTable(handleAction)}
        dataSource={tableContents}
        size="small"
        bordered="true"
        scroll={{ x: true }}
        loading={isLoading}
      />
      <Modal
        title="Expense Category Entry"
        centered
        closable={false}
        maskClosable={false}
        open={isModalOpen}
        onOk={handleModalSave}
        okText={"Save"}
        confirmLoading={isLoading}
        onCancel={() => setIsModalOpen(false)}
      >
        <Form
          form={form}
          name="expense_category_form"
          {...formItemLayout}
          initialValues={currentExpCatState}
        >
          {getExpenseCategoryMaintenanceFields(
            isLoading,
            currentExpCatState,
            setcurrentExpCatState
          ).map((data, index) => (
            <FormInput
              key={index}
              type={data.type}
              name={data.name}
              placeholder={data.placeholder}
              label={data.label}
              autoFocus={data.autofocus}
              value={data.value}
              onChange={data.setValue}
              required={data.required}
              disabled={data.disabled}
              dropdownOptions={data.dropdownOptions}
            />
          ))}
        </Form>
      </Modal>
    </Content>
  );
}
